var _path, _setting;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "#272731",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6801 78.9955C70.6801 72.1069 65.0957 66.5225 58.2071 66.5225H33.2612C26.3725 66.5225 20.7882 72.1069 20.7882 78.9955M87.3107 45.7342C87.3107 68.6963 68.6963 87.3108 45.7342 87.3108C22.7721 87.3108 4.15759 68.6963 4.15759 45.7342C4.15759 22.7721 22.7721 4.15765 45.7342 4.15765C68.6963 4.15765 87.3107 22.7721 87.3107 45.7342ZM62.3648 37.4189C62.3648 46.6037 54.919 54.0495 45.7341 54.0495C36.5493 54.0495 29.1035 46.6037 29.1035 37.4189C29.1035 28.2341 36.5493 20.7883 45.7341 20.7883C54.919 20.7883 62.3648 28.2341 62.3648 37.4189Z",
    stroke: "white",
    strokeWidth: 8,
    strokeDasharray: "429.91461181640625,0,0,0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    begin: "mouseover",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.5s",
    from: "0,0,0,429.91461181640625",
    to: "429.91461181640625,0,0,0",
    fill: "freeze"
  }))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"direct\",\"speed\":20,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2b63adf927dcf3ebdfb13a33ddd43c09.svg";
export { ForwardRef as ReactComponent };